export const BEGINNING = 'BEGINNING'
export const CREDIT_CARD = 'CREDIT_CARD'
export const SURVEY = 'SURVEY'
export const COMPLETED = 'COMPLETED'
